module.exports = __webpack_public_path__ + "static/img/suv-white.1d7bec7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/suv-white.svg
// module id = K3Ym
// module chunks = 82